import { useEffect, useState } from "react";
import SelectBox from "../../../../../utils/components/SelectBox";
import Checkbox from "../../../../../utils/components/Checkbox";

const StepWorkers = ({
  step,
  users,
  handleAction,
  translate,
  workflowType,
}) => {
  const [selectedPersons, setSelectedPersons] = useState([]);
  const [canBeDelegated, setCanBeDelegated] = useState(
    step.settings.step_workers.can_be_delegated || false
  );
  const [setWorkersOnTaskStart, setSetWorkersOnTaskStart] = useState(
    step.settings.step_workers.set_workers_on_task_start || false
  );

  const findUsersById = () => {
    let selectedUsers = [];
    step.settings.step_workers.users.forEach((userId) => {
      const user = users.find((user) => user.user_id === userId);
      if (user) {
        selectedUsers.push({
          id: user.user_id,
          value: user.user_id.toString(),
          label: user.user_name,
        });
      }
    });
    setSelectedPersons(selectedUsers);
  };

  useEffect(() => {
    findUsersById();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (setWorkersOnTaskStart === true) {
      setSelectedPersons([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setWorkersOnTaskStart]);

  useEffect(() => {
    handleAction("step_workers", {
      selectedPersons,
      canBeDelegated,
      setWorkersOnTaskStart,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPersons, canBeDelegated, setWorkersOnTaskStart]);

  return (
    <div>
      <div className="row m-2 pb-4">
        <Checkbox
          label={translate(
            "design_approval_process.step-edit-modal.set-workers-on-task-start"
          )}
          onChange={(value) => setSetWorkersOnTaskStart(value)}
          checked={setWorkersOnTaskStart}
          disabled={workflowType === "auto"}
        />
        <Checkbox
          label={translate(
            "design_approval_process.step-edit-modal.can-be-delegated"
          )}
          onChange={(value) => setCanBeDelegated(value)}
          checked={canBeDelegated}
        />
      </div>
      <div className="row d-flex align-items-end justify-content-start">
        <div className="col-10">
          <p className="text-gray text-uppercase fw-bold mb-3">
            {translate("design_approval_process.step-edit-modal.step-workers")}
          </p>
          <SelectBox
            options={users.map((user) => ({
              id: user.user_id,
              value: user.user_id.toString(),
              label: user.user_name,
            }))}
            placeholder={translate(
              "design_approval_process.step-edit-modal.placeholders.select-step-workers"
            )}
            onChange={(value) => setSelectedPersons(value)}
            value={selectedPersons}
            isMulti={true}
            disabled={setWorkersOnTaskStart || false}
          />
        </div>
      </div>
    </div>
  );
};
export default StepWorkers;
